import { FC } from 'react';
import { TextWithDropShadow } from '../TextWithDropShadow';

interface Props {
  props: {
    footnotes: {
      text: string;
      shadow: boolean;
      display: boolean;
    }[];
    disabled: boolean;
    sectionPadding: boolean;
  };
  className?: string;
  children?: React.ReactNode;
}

export const Footnotes: FC<Props> = ({
  props: { footnotes, disabled },
  className,
  children,
}) => {
  if (disabled) return null;

  const footnoteData = footnotes.filter((footnote) => footnote.display);

  return (
    <div className='mx-6 mt-5 rounded-3xl border border-gray-200 p-6'>
      {footnoteData.map((footnote, index) => {
        return (
          <div key={index} className='pb-6 last:pb-0'>
            <TextWithDropShadow
              text={footnote.text}
              displayShadow={footnote.shadow}
            />
          </div>
        );
      })}
    </div>
  );
};
